var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg80",
    width: 19.2,
    height: 18.35,
    fill: "none",
    viewBox: "0 0 19.2 18.35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m9.6 6.5625v2.1875h2.1875l6.5625-6.5625-2.1875-2.1875zm-6.5624 1.3375c-0.80559 0-1.5782 0.32-2.1478 0.8896-0.56964 0.5697-0.88966 1.3423-0.88966 2.1479s0.32002 1.5782 0.88966 2.1478c0.56965 0.5696 1.3422 0.8897 2.1478 0.8897h13.125c0.3547 0 0.6949 0.1409 0.9457 0.3917s0.3918 0.591 0.3918 0.9458c0 0.3547-0.141 0.6949-0.3918 0.9457s-0.591 0.3918-0.9457 0.3918h-9.1875c-0.4695 0-0.85 0.3805-0.85 0.85 0 0.4694 0.3805 0.85 0.85 0.85h9.1875c0.8055 0 1.5781-0.3201 2.1478-0.8897 0.5696-0.5696 0.8897-1.3422 0.8897-2.1478s-0.3201-1.5782-0.8897-2.1479c-0.5697-0.5696-1.3423-0.8896-2.1478-0.8896h-13.125c-0.35473 0-0.69493-0.141-0.94575-0.3918-0.25083-0.2508-0.39175-0.591-0.39175-0.9457 0-0.3548 0.14092-0.695 0.39175-0.9458 0.25082-0.2508 0.59102-0.3917 0.94575-0.3917h3.0626c0.4694 0 0.85-0.3806 0.85-0.85 0-0.4695-0.3806-0.85-0.85-0.85z",
    clipRule: "evenodd",
    fill: "#787878",
    fillRule: "evenodd"
  })));
}

export default SvgPencil;